import type { RouteRecordRaw } from 'vue-router';

import { ROUTES } from '@/constants/routes';
import i18n from '@/i18n';

import type { BreadcrumbProps } from '@/dsComponents/breadcrumbs/types';

const routes: RouteRecordRaw[] = [
	{
		path: 'profil-agence',
		name: ROUTES.APP.AGENCYPROFILE,
		component: () =>
			import(
				/* webpackChunkName: "agencyProfile" */ './views/AgencyProfile.vue'
			),
		meta: {
			breadcrumbs: <BreadcrumbProps>{
				items: [
					{
						label: i18n.global.t('breadcrumbs.agency.root'),
						icon: 'building-estate',
					},
				],
			},
		},
	},
];

export default routes;
